export default function GuideUnavailable() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-6 text-center">
      <p className="text-4xl mb-4">🏨</p>
      <h1 className="text-lg font-semibold">Guide not available</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        This guide isn't available right now.
        Please ask the front desk for assistance.
      </p>
    </div>
  )
}
